<template>
<div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "corr_in_vehicle_details"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#correctionVehicleDetails">
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Correction in Vehicle Details</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="correctionVehicleDetails">
      <div class="risk row">
          <!--Year of Manufacturing starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-if="correctionInVehicleDetailsData.manufacturingYear.visibility">
            <div class="row form-group">
                    <float-label label="Year of Manufacturing*" :fixed="isFloat(correctionInVehicleDetailsData.manufacturingYear.value)">
                        <datepicker
                        v-model="correctionInVehicleDetailsData.manufacturingYear.value"
                        v-evolvews="correctionInVehicleDetailsData.manufacturingYear"
                        format="yyyy"
                        class="man_year"
                        minimum-view='year'
                        placeholder="Year of Manufacturing*"
                        :disabledDates="disableYearForNb"
                        :input-class="isInputError(correctionInVehicleDetailsData.manufacturingYear.errorText)"
                        @selected="checkError(correctionInVehicleDetailsData.manufacturingYear,false)"
                        @input="checkError(correctionInVehicleDetailsData.manufacturingYear,false)"
                        ></datepicker>
                    </float-label>
                    <span
                        class="error-text"
                        v-if="correctionInVehicleDetailsData.manufacturingYear.errorText !== ''"
                    >{{correctionInVehicleDetailsData.manufacturingYear.errorText}}</span>
                </div>
          </div>
          <!--Year of Manufacturing ends-->
          <!--Vehicle Sub Type starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="correctionInVehicleDetailsData.vehicleSubType.visibility">
          <div class="row form-group">
          <float-label label="Vehicle Sub Type*" :fixed='isFloat(correctionInVehicleDetailsData.vehicleSubType.value)'>
            <select
              @search:blur="checkError(correctionInVehicleDetailsData.vehicleSubType,false)+setErrorClass(correctionInVehicleDetailsData.vehicleSubType,'subtype')"
              :class="{'bgc-error-field': correctionInVehicleDetailsData.vehicleSubType.errorText !== '',
              'remove_placeholder': correctionInVehicleDetailsData.vehicleSubType.value}"
              class="v-select-form form-control subtype"
              @change="updateSubtypeDetails(true)"
              :disabled="subTypeData.length == 1"
              v-model="correctionInVehicleDetailsData.vehicleSubType.value"
              v-evolvews="correctionInVehicleDetailsData.vehicleSubType"
            >
            <option disabled selected value>Vehicle Sub Type*</option>
            <option v-for="subTypeInfo in subTypeData" :key="subTypeInfo.code" :value="subTypeInfo.code">{{subTypeInfo.name}}</option>
            </select>
          </float-label>
          <span
            class="error-text"
            v-if="correctionInVehicleDetailsData.vehicleSubType.errorText!==''"
          >{{correctionInVehicleDetailsData.vehicleSubType.errorText}}</span>
          </div>
        </div>
        <!--Vehicle Sub Type ends-->
        <!--Date of Registration starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-if="correctionInVehicleDetailsData.registrationDate.visibility">
            <div class="row form-group">
                <float-label label="Date of Registration*" :fixed="isFloat(correctionInVehicleDetailsData.registrationDate.value)">
                    <datepicker
                    v-model="correctionInVehicleDetailsData.registrationDate.value"
                    v-evolvews="correctionInVehicleDetailsData.registrationDate"
                    :typeable="true"
                    format="dd/MM/yyyy"
                    placeholder="Date of Registration*"
                    :input-class="isInputError(correctionInVehicleDetailsData.registrationDate.errorText)"
                    @selected="checkError(correctionInVehicleDetailsData.registrationDate,false)"
                    @input="checkError(correctionInVehicleDetailsData.registrationDate,false)"
                    :disabledDates="disablePastYears" 
                    ></datepicker>
                </float-label>
                <span
                    class="error-text"
                    v-if="correctionInVehicleDetailsData.registrationDate.errorText !== ''"
                >{{correctionInVehicleDetailsData.registrationDate.errorText}}</span>
            </div>
          </div>
          <!--Date of Registration ends-->
          <!--GVW* starts -->
          <div class="col-lg-3 col-md-3 col-sm-6" v-if="correctionInVehicleDetailsData.vehicleGVW.visibility && showCommercialVehicleFields" >
            <div class="row form-group">
              <float-label :label="correctionInVehicleDetailsData.vehicleGVW.stepsMandatory ? 'GVW*' : 'GVW'" :fixed="isFloat(correctionInVehicleDetailsData.vehicleGVW.value)"> 
                <input
                  v-model="correctionInVehicleDetailsData.vehicleGVW.value"
                  v-evolvews="correctionInVehicleDetailsData.vehicleGVW"
                  type="text"
                  v-on:keydown="onlyNumber"
                  :disabled="disabledGvwField"
                  maxlength="20"
                  :class="{'bgc-error-field':correctionInVehicleDetailsData.vehicleGVW.errorText !== ''}"
                  class="form-control"
                  :placeholder="correctionInVehicleDetailsData.vehicleGVW.stepsMandatory ? 'GVW*' : 'GVW'"
                />
              </float-label>
               <span class="error-text" v-if="correctionInVehicleDetailsData.vehicleGVW.errorText !== '' && !correctionInVehicleDetailsData.vehicleGVW.errorText.includes('Range')">
                    {{correctionInVehicleDetailsData.vehicleGVW.errorText}}</span>
               <span class="error-text"
                v-if="correctionInVehicleDetailsData.vehicleGVW.errorText !== '' && correctionInVehicleDetailsData.vehicleGVW.errorText.includes('Range')"
               >{{correctionInVehicleDetailsData.vehicleGVW.errorText}}<br><span class="subject-gvw">*Subject to slab values</span>
               </span>
            </div>
          </div>
          <!--GVW* ends-->
      </div>
      <div class="risk row">
        <!--Seating Capacity* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="false">
          <div class="row form-group">
            <float-label label="Seating Capacity" :fixed="isFloat(correctionInVehicleDetailsData.seatingCapacity.value)"> 
              <input
                v-model="correctionInVehicleDetailsData.seatingCapacity.value"
                v-evolvews="correctionInVehicleDetailsData.seatingCapacity"
                maxlength="10"
                type="text"
                v-on:keydown="onlyNumber"
                :class="{'bgc-error-field':correctionInVehicleDetailsData.seatingCapacity.errorText !== '',}"
                class="form-control"
                placeholder="Seating Capacity"
              />
            </float-label>
              <span class="error-text" v-if="correctionInVehicleDetailsData.seatingCapacity.errorText !== ''">
                  {{correctionInVehicleDetailsData.seatingCapacity.errorText}}</span>
          </div>
        </div>
        <!--Engine Number* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="correctionInVehicleDetailsData.engineNumber.visibility">
          <div class="row form-group">
            <float-label label="Engine Number*" :fixed="isFloat(correctionInVehicleDetailsData.engineNumber.value)"> 
              <input
                v-model="correctionInVehicleDetailsData.engineNumber.value"
                v-evolvews="correctionInVehicleDetailsData.engineNumber"
                type="text"
                maxlength="20"
                v-on:keydown="alphaNumeric"
                :class="{'bgc-error-field':correctionInVehicleDetailsData.engineNumber.errorText !== '',}"
                class="form-control capital-input"
                placeholder="Engine Number*"
              />
            </float-label>
              <span class="error-text" v-if="correctionInVehicleDetailsData.engineNumber.errorText !== ''">
                  {{correctionInVehicleDetailsData.engineNumber.errorText}}</span>
          </div>
        </div>
        <!--Engine Number* ends-->
        <!--Chassis Number* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="correctionInVehicleDetailsData.chassisNo.visibility">
          <div class="row form-group">
            <float-label label="Chassis Number*" :fixed="isFloat(correctionInVehicleDetailsData.chassisNo.value)"> 
              <input
                v-model="correctionInVehicleDetailsData.chassisNo.value"
                v-evolvews="correctionInVehicleDetailsData.chassisNo"
                type="text"
                v-on:keydown="alphaNumeric"
                maxLength="30"
                :class="{'bgc-error-field':correctionInVehicleDetailsData.chassisNo.errorText !== '',}"
                class="form-control  capital-input"
                placeholder="Chassis Number*"
              />
            </float-label>
              <span class="error-text" v-if="correctionInVehicleDetailsData.chassisNo.errorText !== ''">
                  {{correctionInVehicleDetailsData.chassisNo.errorText}}</span>
          </div>
        </div>
        <!--Chassis Number* ends-->  
      </div>
      <div class="risk row" v-if="correctionInVehicleDetailsData.batteryIdv.visibility && showBatteryDetails">
        <!-- Battery IDV section Starts here-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
          <float-label 
            label="Battery IDV" 
            :fixed="isFloat(correctionInVehicleDetailsData.batteryIdv.value)">
            <input type="text" 
            placeholder="Battery IDV" 
            class="form-control"
            v-model="correctionInVehicleDetailsData.batteryIdv.value"
            :class="{ 'bgc-error-field': correctionInVehicleDetailsData.batteryIdv.errorText!=='' }"
            :disabled="correctionInVehicleDetailsData.batteryIdv.value=='0'"
            v-evolvews="correctionInVehicleDetailsData.batteryIdv"
            maxlength="7"
            v-on:keydown="onlyNumber">
          </float-label>
          <span class="error-text"
          v-if=" correctionInVehicleDetailsData.batteryIdv.errorText!==''"
          >{{ correctionInVehicleDetailsData.batteryIdv.errorText}}</span> 
        </div>   
        <!-- Battery IDV section closed here-->
        <!-- Removable/Fixed Battery section starts here-->
        <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
          <float-label 
            label="Removable/Fixed Battery" 
            :fixed="isFloat(correctionInVehicleDetailsData.removableFixedBattery.value)">
            <select class="form-control bg-error"
              v-model="correctionInVehicleDetailsData.removableFixedBattery.value"
              placeholder="Removable/Fixed Battery">
              <option disabled selected value="">Removable/Fixed Battery</option>
              <option value="REMOVABLE">Removable</option>
              <option value='FIXED'>Fixed</option>
              <option value='EXTERNAL'>External</option>
            </select>
          </float-label>
        </div>
        <!-- Removable/Fixed Battery section closed here-->
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <div class="row form-group adv-search-div">
                <a href="#/" class="add-wrapper bgc-links mt-3 adv-search drop collapsed" data-toggle="collapse"
                    data-target="#additional_battery_details">Edit/ Add Battery Details
                </a>
            </div>
        </div>
      </div>
      <div id="additional_battery_details" class="collapse" v-if="correctionInVehicleDetailsData.batteryIdv.visibility && showBatteryDetails">
        <div class="col-12 p-0 accordion-toggle mt-3">
          <div class="row">
            <h3 class="col-12 pl-0">Additional Battery Details</h3>
          </div>
        </div>
        <div class="risk row">
          <!-- Battery Type section start here-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label 
              label="Battery Type" 
              :fixed="isFloat(correctionInVehicleDetailsData.batteryType.value)">
              <select 
                class="form-control bg-error"
                v-model="correctionInVehicleDetailsData.batteryType.value" 
                placeholder="Battery Type"
                :class="{ 'bgc-error-field': correctionInVehicleDetailsData.batteryType.errorText!=='' }"
                v-evolvews="correctionInVehicleDetailsData.batteryType">
                <option disabled selected value="" v-if="correctionInVehicleDetailsData.batteryType.value==''">Battery Type</option>
                <option disabled selected :value='null' v-if='correctionInVehicleDetailsData.batteryType.value==null'>Battery Type</option>
                <option value="Lead Acid">Lead Acid</option>
                <option value="Lithium">Lithium</option>
                <option value="Lead Acid + Lithium">Lead Acid+Lithium</option>
              </select>
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.batteryType.errorText!==''"
              >{{ correctionInVehicleDetailsData.batteryType.errorText}}</span> 
          </div>
          <!-- Battery Type section closed here-->
          
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <div class="row half-width">
              <!--Battery Manufacturing Date starts-->
              <div class="col-lg-7 col-md-6 col-sm-12 p-0 inside-half-width">
                <float-label 
                  label="Manufacturing Date" 
                  :fixed="isFloat(correctionInVehicleDetailsData.batteryManufacturingDate.value)">
                  <datepicker
                    :typeable="true"
                    format="dd/MM/yyyy"
                    id="start_date"
                    class="manufacturing-date"
                    placeholder="Manufacturing Date"
                    :disabledDates="disableManufacturingDate"
                    v-model="correctionInVehicleDetailsData.batteryManufacturingDate.value"
                    v-on:keydown="onlyNumber"
                    :input-class="isInputError(correctionInVehicleDetailsData.batteryManufacturingDate.errorText)"          
                    @datePickerBlurred="checkError(correctionInVehicleDetailsData.batteryManufacturingDate,false)"
                  ></datepicker>
                </float-label>
                <span
                  class="error-text"
                  v-if="correctionInVehicleDetailsData.batteryManufacturingDate.errorText!==''"
                >{{correctionInVehicleDetailsData.batteryManufacturingDate.errorText}}</span>
              </div>
              <!--Battery Manufacturing Date ends-->
              <!--Battery Warranty starts-->
              <div class="col-lg-5 col-md-6 col-sm-12 p-0 inside-half-width">
                <float-label 
                  label="Warranty" 
                  :fixed="isFloat(correctionInVehicleDetailsData.batteryWarranty.value)">
                  <select class="form-control bg-error"
                    v-model="correctionInVehicleDetailsData.batteryWarranty.value" 
                    placeholder="Warranty"
                    :class="{ 'bgc-error-field': correctionInVehicleDetailsData.batteryWarranty.errorText!=='' }"
                    v-evolvews="correctionInVehicleDetailsData.batteryWarranty">
                    <!-- <option disabled value>Warranty</option> -->
                    <option disabled selected value="" v-if="correctionInVehicleDetailsData.batteryWarranty.value==''">Warranty</option>
                    <option disabled selected :value='null' v-if='correctionInVehicleDetailsData.batteryWarranty.value==null'>Warranty</option> 
                    <option value="NA">NA</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value=">5">&gt;5</option>
                  </select>
                </float-label>
                <span class="error-text"
                  v-if=" correctionInVehicleDetailsData.batteryWarranty.errorText!==''"
                  >{{ correctionInVehicleDetailsData.batteryWarranty.errorText}}</span> 
              </div>
              <!--Warranty ends-->

            </div>
          </div>
          <!--Temperature Zone starts-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label 
              label="Temperature Zone" 
              :fixed="isFloat(correctionInVehicleDetailsData.temperatureZone.value)">
              <select class="form-control bg-error"
                v-model="correctionInVehicleDetailsData.temperatureZone.value"
                placeholder="Temperature Zone"
                :class="{ 'bgc-error-field': correctionInVehicleDetailsData.temperatureZone.errorText!=='' }"
                v-evolvews="correctionInVehicleDetailsData.temperatureZone">
                <option disabled selected value="" v-if="correctionInVehicleDetailsData.temperatureZone.value==''">
                Temperature Zone</option>
                <option disabled selected :value='null' v-if="correctionInVehicleDetailsData.temperatureZone.value==null">
                Temperature Zone</option>
                <option value="ZONE A">ZONE A</option>
                <option value="ZONE B">ZONE B</option>
                <option value="ZONE C">ZONE C</option>
                <option value="ZONE D">ZONE D</option>
                <option value="ZONE E">ZONE E</option>
              </select>
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.temperatureZone.errorText!==''"
              >{{ correctionInVehicleDetailsData.temperatureZone.errorText}}</span> 
          </div>
          <!--Temperature Zone ends-->
          <!--Battery Serial Number starts-->
          <!-- <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
              <float-label label="Battery Serial Number" :fixed="isFloat(correctionInVehicleDetailsData.batterySerialNumber.value)"> 
                <input
                  v-model="correctionInVehicleDetailsData.batterySerialNumber.value"
                  v-evolvews="correctionInVehicleDetailsData.batterySerialNumber"
                  type="text"
                  v-on:keydown="onlyNumber"
                  class="form-control"
                  placeholder="Battery Serial Number"
                />
              </float-label>
               <span class="error-text" v-if="correctionInVehicleDetailsData.batterySerialNumber.errorText !== ''">
                    {{correctionInVehicleDetailsData.batterySerialNumber.errorText}}</span>
            </div>
          </div> -->
          <!--Battery Serial Number* ends-->  
        </div>
        <div class="risk row">
          <!--Charge Infra Available starts-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label 
              label="Charge Infra Available InHouse Or Public" 
              :fixed="isFloat(correctionInVehicleDetailsData.chargeInfraAvailableInHouseOrPublic.value)">
              <select
                class="form-control bg-error"
                placeholder="Charge Infra Available InHouse Or Public"
                v-model="correctionInVehicleDetailsData.chargeInfraAvailableInHouseOrPublic.value"
                :class="{ 'bgc-error-field': correctionInVehicleDetailsData.chargeInfraAvailableInHouseOrPublic.errorText!=='' }"
                v-evolvews="correctionInVehicleDetailsData.chargeInfraAvailableInHouseOrPublic"
              >
                <option disabled selected value="" v-if="correctionInVehicleDetailsData.chargeInfraAvailableInHouseOrPublic.value==''">Charge Infra Available (In-House/Public)</option>
                <option disabled selected :value='null' v-if='correctionInVehicleDetailsData.chargeInfraAvailableInHouseOrPublic.value==null'>Charge Infra Available (In-House/Public)</option>
                <option value="INHOUSE">In-house</option>
                <option value="PUBLIC">Public</option>
              </select>
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.chargeInfraAvailableInHouseOrPublic.errorText!==''"
              >{{ correctionInVehicleDetailsData.chargeInfraAvailableInHouseOrPublic.errorText}}</span> 
          </div>
          <!--Charge Infra Available ends-->
          <!--AC/DC Charger starts-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label 
              label="AC/DC Charger" 
              :fixed="isFloat(correctionInVehicleDetailsData.acDCCharger.value)">
              <select class="form-control bg-error"
              v-model="correctionInVehicleDetailsData.acDCCharger.value" 
              placeholder="AC/DC Charger"
              :class="{ 'bgc-error-field': correctionInVehicleDetailsData.acDCCharger.errorText!=='' }"
              v-evolvews="correctionInVehicleDetailsData.acDCCharger">
                <option  disabled selected value="" v-if="correctionInVehicleDetailsData.acDCCharger.value==''">AC/DC Charger</option>
                <option  disabled selected :value='null' v-if='correctionInVehicleDetailsData.acDCCharger.value==null'>AC/DC Charger</option>
                <option value="AC">AC Charger</option>
                <option value="DC">DC Charger</option>
                <option value="Others">Others</option>
              </select>
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.acDCCharger.errorText!==''"
              >{{ correctionInVehicleDetailsData.acDCCharger.errorText}}</span> 
          </div>
          <!--AC/DC Charger ends-->
          <!--Part Type(Fibre/metal) starts-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label 
              label="Part Type(Fibre/metal)" 
              :fixed="isFloat(correctionInVehicleDetailsData.partTypeFiberOrMetal.value)">
              <select class="form-control bg-error"
              v-model="correctionInVehicleDetailsData.partTypeFiberOrMetal.value" 
              placeholder="Part Type(Fibre/metal)"
              :class="{ 'bgc-error-field': correctionInVehicleDetailsData.partTypeFiberOrMetal.errorText!=='' }"
              v-evolvews="correctionInVehicleDetailsData.partTypeFiberOrMetal">
                <option disabled selected value="" v-if="correctionInVehicleDetailsData.partTypeFiberOrMetal.value==''">Part Type(Fibre/metal)</option>
                <option disabled selected value='null' v-if='correctionInVehicleDetailsData.partTypeFiberOrMetal.value==null'>Part Type(Fibre/metal)</option>
                <option value="FIBER">Fiber</option>
                <option value="METAL">Metal</option>
                <option value="MIX">Mix</option>
              </select>
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.partTypeFiberOrMetal.errorText!==''"
              >{{ correctionInVehicleDetailsData.partTypeFiberOrMetal.errorText}}</span> 
          </div>
          <!--Part Type(Fibre/metal) ends-->
          <!--Battery Make starts-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label 
              label="Battery Make" 
              :fixed="isFloat(correctionInVehicleDetailsData.batteryMake.value)">
              <input type="text" 
              placeholder="Battery Make" 
              class="form-control"
              v-model="correctionInVehicleDetailsData.batteryMake.value"
              :class="{ 'bgc-error-field': correctionInVehicleDetailsData.batteryMake.errorText!=='' }"
              v-evolvews="correctionInVehicleDetailsData.batteryMake">
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.batteryMake.errorText!==''"
              >{{ correctionInVehicleDetailsData.batteryMake.errorText}}</span> 
          </div>
          <!--Battery Make ends-->
        </div>
        <div class="risk row">
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <div class="row half-width">
              <!--Battery Power starts-->
              <div class="col-lg-6 col-md-6 col-sm-12 p-0 inside-half-width">
                <float-label 
                  label="Battery Power(V/Ah)" 
                  :fixed="isFloat(correctionInVehicleDetailsData.batteryPowerVOrAh.value)">
                  <input type="text" 
                  placeholder="Battery Power" 
                  class="form-control"
                  v-model="correctionInVehicleDetailsData.batteryPowerVOrAh.value"
                  :class="{ 'bgc-error-field': correctionInVehicleDetailsData.batteryPowerVOrAh.errorText!=='' }"
                  v-evolvews="correctionInVehicleDetailsData.batteryPowerVOrAh"
                  v-on:keydown="onlyNumber">
                </float-label>
                <span class="error-text" v-if=" correctionInVehicleDetailsData.batteryPowerVOrAh.errorText!==''">
                  {{ correctionInVehicleDetailsData.batteryPowerVOrAh.errorText}}
                </span>
              </div>
              <!--Battery Power ends-->
              <!--Cells starts-->
              <div class="col-lg-6 col-md-6 col-sm-12 p-0 mt-lg-0 mt-md-0 mt-1 inside-half-width">
                <float-label 
                  label="Cells" 
                  :fixed="isFloat(correctionInVehicleDetailsData.cells.value)">
                  <input type="text" 
                  placeholder="Cells" 
                  class="form-control"
                  v-model="correctionInVehicleDetailsData.cells.value"
                  :class="{ 'bgc-error-field': correctionInVehicleDetailsData.cells.errorText!=='' }"
                  v-on:keydown="onlyNumber"
                  v-evolvews="correctionInVehicleDetailsData.cells">
                </float-label>
                <span class="error-text"
                  v-if=" correctionInVehicleDetailsData.cells.errorText!==''"
                  >{{ correctionInVehicleDetailsData.cells.errorText}}</span>
              </div>
              <!--Cells ends-->
            </div>
          </div>
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <div class="row half-width">
            <!--Battery Age starts-->
              <div class="col-lg-6 col-md-6 col-sm-12 p-0 inside-half-width">
                <float-label 
                  label="Battery Age" 
                  :fixed="isFloat(correctionInVehicleDetailsData.batteryAge.value)">
                  <input type="text" 
                  placeholder="Battery Age" 
                  class="form-control"
                  v-model="correctionInVehicleDetailsData.batteryAge.value"
                  :class="{ 'bgc-error-field': correctionInVehicleDetailsData.batteryAge.errorText!=='' }"
                  v-evolvews="correctionInVehicleDetailsData.batteryAge"
                  v-on:keydown="onlyNumber">
                </float-label>
                <span class="error-text"
                  v-if=" correctionInVehicleDetailsData.batteryAge.errorText!==''"
                  >{{ correctionInVehicleDetailsData.batteryAge.errorText}}</span> 
              </div>
              <!--Battery Age ends-->
              <!--Battery Weight starts-->
              <div class="col-lg-6 col-md-6 col-sm-12 p-0 mt-lg-0 mt-md-0 mt-1 inside-half-width">
                <float-label 
                  label="Battery Weight" 
                  :fixed="isFloat(correctionInVehicleDetailsData.batteryWeight.value)">
                  <input 
                  type="text" 
                  placeholder="Battery Weight" 
                  class="form-control"
                  v-model="correctionInVehicleDetailsData.batteryWeight.value"
                  :class="{ 'bgc-error-field': correctionInVehicleDetailsData.batteryWeight.errorText!=='' }"
                  v-evolvews="correctionInVehicleDetailsData.batteryWeight"
                  v-on:keydown="onlyNumber">
                </float-label>
                <span class="error-text"
                  v-if=" correctionInVehicleDetailsData.batteryWeight.errorText!==''"
                  >{{ correctionInVehicleDetailsData.batteryWeight.errorText}}</span> 
              </div>
              <!--Battery Weight ends-->
            </div>
          </div>
          <!--Power/Weight Ratio starts-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label 
              label="Power/Weight Ratio" 
              :fixed="isFloat(correctionInVehicleDetailsData.powerWeightRatio.value)">
              <input type="text" 
              placeholder="Power/Weight Ratio" 
              class="form-control"
              v-model="correctionInVehicleDetailsData.powerWeightRatio.value"
              :class="{ 'bgc-error-field': correctionInVehicleDetailsData.powerWeightRatio.errorText!=='' }"
              v-on:keydown="onlyNumber"
              v-evolvews="correctionInVehicleDetailsData.powerWeightRatio">
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.powerWeightRatio.errorText!==''"
              >{{ correctionInVehicleDetailsData.powerWeightRatio.errorText}}</span> 
          </div>
          <!--Power/Weight Ratio ends-->
          <!--Speed/Weight Ratio starts-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label 
              label="Speed/Weight Ratio" 
              :fixed="isFloat(correctionInVehicleDetailsData.speedWeightRatio.value)">
              <input type="text" 
              placeholder="Speed/Weight Ratio" 
              class="form-control"
              v-model="correctionInVehicleDetailsData.speedWeightRatio.value"
              :class="{ 'bgc-error-field': correctionInVehicleDetailsData.speedWeightRatio.errorText!=='' }"
              v-on:keydown="onlyNumber"
              v-evolvews="correctionInVehicleDetailsData.speedWeightRatio">
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.speedWeightRatio.errorText!==''"
              >{{ correctionInVehicleDetailsData.speedWeightRatio.errorText}}</span> 
          </div>
          <!--Speed/Weight Ratio ends-->
        </div>
        <div class="risk row">
          <!--Motor/Battery Power Ratio starts-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label 
              label="Motor/Battery Power Ratio"  
              :fixed="isFloat(correctionInVehicleDetailsData.motorBatteryPowerRatio.value)">
              <input type="text" 
              placeholder="Motor/Battery Power Ratio" 
              class="form-control"
              v-model="correctionInVehicleDetailsData.motorBatteryPowerRatio.value"
              :class="{ 'bgc-error-field': correctionInVehicleDetailsData.motorBatteryPowerRatio.errorText!=='' }"
              v-on:keydown="onlyNumber"
              v-evolvews="correctionInVehicleDetailsData.motorBatteryPowerRatio">
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.motorBatteryPowerRatio.errorText!==''"
              >{{ correctionInVehicleDetailsData.motorBatteryPowerRatio.errorText}}</span> 
          </div>
          <!--Motor/Battery Power Ratio ends-->
          <!--Electric Motor Power(KWH/BHP) starts-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label 
              label="Electric Motor Power(KWH/BHP)" 
              :fixed="isFloat(correctionInVehicleDetailsData.electricMotorPowerKwhOrBhp.value)">
              <input type="text" 
              placeholder="Electric Motor Power(KWH/BHP)" 
              class="form-control"
              v-model="correctionInVehicleDetailsData.electricMotorPowerKwhOrBhp.value"
              :class="{ 'bgc-error-field': correctionInVehicleDetailsData.electricMotorPowerKwhOrBhp.errorText!=='' }"
              v-on:keydown="onlyNumber"
              v-evolvews="correctionInVehicleDetailsData.electricMotorPowerKwhOrBhp">
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.electricMotorPowerKwhOrBhp.errorText!==''"
              >{{ correctionInVehicleDetailsData.electricMotorPowerKwhOrBhp.errorText}}</span> 
          </div>
          <!--Electric Motor Power(KWH/BHP) ends-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <div class="row half-width">
              <div class="col-lg-6 col-md-6 col-sm-12 p-0 inside-half-width">
                <!--Range(In km in single charge ) starts-->
                <float-label 
                  label="Range(In km in single charge )" 
                  :fixed="isFloat(correctionInVehicleDetailsData.rangeInKmInSingleCharge.value)">
                  <input type="text" 
                  placeholder="Range(In km in single charge )" 
                  class="form-control"
                  v-model="correctionInVehicleDetailsData.rangeInKmInSingleCharge.value"
                  :class="{ 'bgc-error-field': correctionInVehicleDetailsData.rangeInKmInSingleCharge.errorText!=='' }"
                  v-on:keydown="onlyNumber"
                  v-evolvews="correctionInVehicleDetailsData.rangeInKmInSingleCharge">
                </float-label>
                <span class="error-text"
                  v-if=" correctionInVehicleDetailsData.rangeInKmInSingleCharge.errorText!==''"
                  >{{ correctionInVehicleDetailsData.rangeInKmInSingleCharge.errorText}}</span> 
                <!--Range(In km in single charge ) ends-->
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 p-0 mt-lg-0 mt-md-0 mt-1 inside-half-width">
                  <!--Max Speed starts-->
                <float-label 
                  label="Max Speed" 
                  :fixed="isFloat(correctionInVehicleDetailsData.maxSpeed.value)">
                  <input type="text" 
                  placeholder="Max Speed" 
                  class="form-control"
                  v-model="correctionInVehicleDetailsData.maxSpeed.value"
                  :class="{ 'bgc-error-field': correctionInVehicleDetailsData.maxSpeed.errorText!=='' }"
                  v-on:keydown="onlyNumber"
                  v-evolvews="correctionInVehicleDetailsData.maxSpeed">
                </float-label>
                <span class="error-text"
                  v-if=" correctionInVehicleDetailsData.maxSpeed.errorText!==''"
                  >{{ correctionInVehicleDetailsData.maxSpeed.errorText}}</span> 
                  <!--Max Speed ends-->
              </div>
            </div>
          </div>
          <!--Vehicle Weight With Battery starts-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label 
              label="Vehicle Weight With Battery" 
              :fixed="isFloat(correctionInVehicleDetailsData.vehicleWeightWithBattery.value)">
              <input type="text" 
              placeholder="Vehicle Weight With Battery" 
              class="form-control"
              v-model="correctionInVehicleDetailsData.vehicleWeightWithBattery.value"
              :class="{ 'bgc-error-field': correctionInVehicleDetailsData.vehicleWeightWithBattery.errorText!=='' }"
              v-on:keydown="onlyNumber"
              v-evolvews="correctionInVehicleDetailsData.vehicleWeightWithBattery">
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.vehicleWeightWithBattery.errorText!==''"
              >{{ correctionInVehicleDetailsData.vehicleWeightWithBattery.errorText}}</span> 
          </div>
          <!--Vehicle Weight With Battery ends-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <!--Vehicle Weight Without Battery starts-->
            <float-label 
              label="Vehicle Weight Without Battery" 
              :fixed="isFloat(correctionInVehicleDetailsData.vehicleWeightWithoutBattery.value)">
              <input type="text" 
              placeholder="Vehicle Weight Without Battery" 
              class="form-control"
              v-model="correctionInVehicleDetailsData.vehicleWeightWithoutBattery.value"
              v-on:keydown="onlyNumber"
              :class="{ 'bgc-error-field': correctionInVehicleDetailsData.vehicleWeightWithoutBattery.errorText!=='' }"
              v-evolvews="correctionInVehicleDetailsData.vehicleWeightWithoutBattery">
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.vehicleWeightWithoutBattery.errorText!==''"
              >{{ correctionInVehicleDetailsData.vehicleWeightWithoutBattery.errorText}}</span>
              <!--Vehicle Weight Without Battery ends-->
          </div>
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <div class="row half-width">
              <div class="col-lg-6 col-md-6 col-sm-12 p-0 inside-half-width">
              <!--Acceleration(KM/Sec) starts-->
                <float-label 
                  label="Acceleration(KM/Sec)" 
                  :fixed="isFloat(correctionInVehicleDetailsData.acceleration.value)">
                  <input type="text" 
                  placeholder="Acceleration(KM/Sec)" 
                  class="form-control"
                  v-model="correctionInVehicleDetailsData.acceleration.value"
                  :class="{ 'bgc-error-field': correctionInVehicleDetailsData.acceleration.errorText!=='' }"
                  v-evolvews="correctionInVehicleDetailsData.acceleration"
                  v-on:keydown="onlyNumber">
                </float-label>
                <span class="error-text"
                  v-if=" correctionInVehicleDetailsData.acceleration.errorText!==''"
                  >{{ correctionInVehicleDetailsData.acceleration.errorText}}</span> 
              <!--Acceleration(KM/Sec) ends-->
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 p-0 mt-lg-0 mt-md-0 mt-1 inside-half-width">
              <!--Charging Hours starts-->
                <float-label 
                  label="Charging Hours" 
                  :fixed="isFloat(correctionInVehicleDetailsData.chargingHours.value)">
                  <input type="text" 
                  placeholder="Charging Hours" 
                  class="form-control"
                  v-model="correctionInVehicleDetailsData.chargingHours.value"
                  :class="{ 'bgc-error-field': correctionInVehicleDetailsData.chargingHours.errorText!=='' }"
                  v-evolvews="correctionInVehicleDetailsData.chargingHours"
                  v-on:keydown="onlyNumber">
                </float-label>
                <span class="error-text"
                  v-if=" correctionInVehicleDetailsData.chargingHours.errorText!==''"
                  >{{ correctionInVehicleDetailsData.chargingHours.errorText}}</span>
              <!--Charging Hours ends-->
              </div>
            </div>
          </div>
          <!--Area Infrastructure starts-->
          <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
            <float-label 
              label="Area Infrastructure " 
              :fixed="isFloat(correctionInVehicleDetailsData.areaInfrastructure.value)">
              <input type="text" 
              placeholder="Area Infrastructure " 
              class="form-control" disabled
              v-model="correctionInVehicleDetailsData.areaInfrastructure.value"
              :class="{ 'bgc-error-field': correctionInVehicleDetailsData.areaInfrastructure.errorText!=='' }"
              v-evolvews="correctionInVehicleDetailsData.areaInfrastructure">
            </float-label>
            <span class="error-text"
              v-if=" correctionInVehicleDetailsData.areaInfrastructure.errorText!==''"
              >{{ correctionInVehicleDetailsData.areaInfrastructure.errorText}}</span> 
          </div>
          <!--Area Infrastructure ends-->
        </div>
        <!--Battery radio button starts-->
        <div class="row">
          <div class="col-12 d-flex pl-0">
            <div class="radio-status pl-1">
              <input value="NEW" type="radio" class="bgc-radio" id="New" name="Battery"
              v-model="correctionInVehicleDetailsData.newUsedBattery.value">
              <label class="mt-3 mr-2" for="New">New Battery</label>
              <input value="USED" type="radio" class="bgc-radio" id="Used" name="Battery"
              v-model="correctionInVehicleDetailsData.newUsedBattery.value">
              <label class="mt-3 ml-4" for="Used">Old Battery</label>
            </div>
          </div>
        </div>
        <!--Battery radio button ends-->
        <div class="col-12">
          <div class="row">
            <div class="col-12 bgc-form-box pl-0">
              <div class="row">
                <div class="form-group col-lg-6 col-md-6 col-sm-12 pl-0 pr-0 pr-md-4 pr-lg-4">
                  <div class="color-even row m-0">
                    <div class="col-lg-8 col-md-6 col-sm-8 mt-3 pl-5">Use For Rental</div>
                    <div class="col-lg-4 col-md-6 col-sm-4 pb-2 pl-5 pl-lg-3 pl-md-3">
                      <input
                        value="YES"
                        type="radio"
                        class="bgc-radio"
                        id="rental-yes"
                        name="Battery1"
                        v-model="correctionInVehicleDetailsData.useForRental.value"
                      >
                      <label class="mt-3 mr-2" for="rental-yes">Yes</label>
                      <input
                        value="NO"
                        type="radio"
                        class="bgc-radio"
                        id="rental-no"
                        name="Battery1"
                        v-model="correctionInVehicleDetailsData.useForRental.value"
                      >
                      <label class="mt-3 ml-4" for="rental-no">No</label>
                    </div>
                  </div>
                  <div class="row ml-0 mt-2">
                    <div
                      class="col-lg-8 col-md-6 col-sm-8 mt-3 pl-5"
                    >Connected To Other Systems (Central System)</div>
                    <div class="col-lg-4 col-md-6 col-sm-4 pb-2 pl-5 pl-lg-2 pl-md-2 mobile-central">
                      <input
                        value="YES"
                        type="radio"
                        class="bgc-radio"
                        id="central-system-yes"
                        name="Battery2"
                        v-model="correctionInVehicleDetailsData.connectedToOtherSystemsOrCentralSystem.value"
                      >
                      <label class="mt-3 mr-2" for="central-system-yes">Yes</label>
                      <input
                        value="NO"
                        type="radio"
                        class="bgc-radio"
                        id="central-system-no"
                        name="Battery2"
                        v-model="correctionInVehicleDetailsData.connectedToOtherSystemsOrCentralSystem.value"
                      >
                      <label class="mt-3 ml-4" for="central-system-no">No</label>
                    </div>
                  </div>
                  <div class="color-even row m-0">
                    <div class="col-lg-8 col-md-6 col-sm-8 mt-3 pl-5">Battery Is Leased</div>
                    <div class="col-lg-4 col-md-6 col-sm-4 pb-2 pl-5 pl-lg-3 pl-md-3">
                      <input
                        value="YES"
                        selected
                        type="radio"
                        class="bgc-radio"
                        id="battery-leased-yes"
                        name="Battery3"
                        v-model="correctionInVehicleDetailsData.batteryIsLeased.value"
                      >
                      <label class="mt-3 mr-2" for="battery-leased-yes">Yes</label>
                      <input
                        value="NO"
                        type="radio"
                        class="bgc-radio"
                        id="battery-leased-no"
                        name="Battery3"
                        v-model="correctionInVehicleDetailsData.batteryIsLeased.value"
                        checked
                      >
                      <label class="mt-3 ml-4" for="battery-leased-no">No</label>
                    </div>
                  </div>
                  <div class="color-even row m-0" v-if="correctionInVehicleDetailsData.batteryIsLeased.value == 'YES'">
                    <div class="col-12 mt-3 pl-5">Lease Details</div>
                    <div class="col-12 mt-2 pb-5 pl-3 pr-5">
                      <input type="text" class="ml-4 mr-2"
                      v-model="correctionInVehicleDetailsData.batteryLeaseDetails.value">
                    </div>
                  </div>
                </div>
                <div class="form-group col-lg-6 col-md-6 col-sm-12 pl-0">
                  <div class="color-even row ml-0">
                    <div
                      class="col-lg-8 col-md-6 col-sm-8 mt-3 pl-5"
                    >Additional Battery/Charging Protection</div>
                    <div class="col-lg-4 col-md-6 col-sm-4 pb-2 pl-5 pl-lg-3 pl-md-3">
                      <input
                        value="YES"
                        type="radio"
                        class="bgc-radio"
                        id="additional-battery-yes"
                        name="Battery4"
                        v-model="correctionInVehicleDetailsData.additionalBatteryChargingProtection.value"
                      >
                      <label class="mt-3 mr-2" for="additional-battery-yes">Yes</label>
                      <input
                        value="NO"
                        type="radio"
                        class="bgc-radio"
                        id="additional-battery-no"
                        name="Battery4"
                        v-model="correctionInVehicleDetailsData.additionalBatteryChargingProtection.value"
                      >
                      <label class="radioNoButton mt-3 ml-4" for="additional-battery-no">No</label>
                    </div>
                  </div>
                  <div class="row ml-0 mt-2">
                    <div class="col-lg-8 col-md-6 col-sm-8 mt-3 pl-5">Power Fluctuation</div>
                    <div class="col-lg-4 col-md-6 col-sm-4 pb-2 pl-5 pl-lg-3 pl-md-3">
                      <input
                        value="YES"
                        type="radio"
                        class="bgc-radio"
                        id="power-fluctuation-yes"
                        name="Battery5"
                        v-model="correctionInVehicleDetailsData.powerFluctuation.value"
                      >
                      <label class="mt-3 mr-2" for="power-fluctuation-yes">Yes</label>
                      <input
                        value="NO"
                        type="radio"
                        class="bgc-radio"
                        id="power-fluctuation-no"
                        name="Battery5"
                        v-model="correctionInVehicleDetailsData.powerFluctuation.value"
                      >
                      <label class="mt-3 ml-4" for="power-fluctuation-no">No</label>
                    </div>
                  </div>
                  <div class="color-even row ml-0 mt-2">
                    <div class="col-lg-8 col-md-6 col-sm-8 mt-3 pl-5">Battery Claims</div>
                    <div class="col-lg-4 col-md-6 col-sm-4 pb-2 pl-5 pl-lg-3 pl-md-3">
                      <input
                        value="YES"
                        type="radio"
                        class="bgc-radio"
                        id="battery-claims-yes"
                        name="Battery6"
                        v-model="correctionInVehicleDetailsData.batteryClaims.value"
                      >
                      <label class="mt-3 mr-2" for="battery-claims-yes">Yes</label>
                      <input
                        value="NO"
                        type="radio"
                        checked
                        class="bgc-radio"
                        id="battery-claims-no"
                        name="Battery6"
                        v-model="correctionInVehicleDetailsData.batteryClaims.value"
                      >
                      <label class="mt-3 ml-4" for="battery-claims-no">No</label>
                    </div>
                  </div>
                  <div class="color-even row ml-0 claim-height" v-if="correctionInVehicleDetailsData.batteryClaims.value == 'YES'">
                    <div class="col-lg-8 col-md-8 col-sm-8 mt-3 pl-5">
                      No. Of Claims
                      <div>
                        <input type="text" class="claimTextBox"
                        v-model="correctionInVehicleDetailsData.noOfClaims.value" v-on:keydown="onlyNumber">
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 pl-1 mt-3 pl-5 pl-md-0 pl-lg-0">
                      Claim Amount
                      <div>
                        <input type="text" class="claimTextBox"
                        v-model="correctionInVehicleDetailsData.claimAmount.value" v-on:keydown="onlyNumber">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div class="row ml-lg-3 pl-lg-1 mt-2">
            <div class="col-lg-3 col-md-3 col-sm-4 col-6 mt-3">Battery with GPS</div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-6 pb-2 pl-lg-5 ml-lg-4">
              <input
                value="YES"
                v-model="correctionInVehicleDetailsData.batteryWithGps.value" 
                type="radio" 
                class="bgc-radio" 
                id="batteryWithGps"
                name="batterywithgps"
              >
              <label class="mt-3 mr-2" for="batteryWithGps">Yes</label>
              <input
                value="NO"
                v-model="correctionInVehicleDetailsData.batteryWithGps.value" 
                type="radio" 
                class="bgc-radio" 
                id="batteryWithoutGps"
                name="batterywithgps"
              >
              <label class="mt-3 ml-4" for="batteryWithoutGps">No</label>
            </div>
          </div>
      </div>
      <div class="risk row" v-if="correctionInVehicleDetailsData.tyre1SerialNo.visibility && showTyreFields">
          <!--Tyre 1 Serial Number* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-show="showTyreFieldSpecific('1')">
            <div class="row form-group">
              <float-label label="Tyre 1 Serial Number*" :fixed="isFloat(correctionInVehicleDetailsData.tyre1SerialNo.value)"> 
                <input
                  v-model="correctionInVehicleDetailsData.tyre1SerialNo.value"
                  v-evolvews="correctionInVehicleDetailsData.tyre1SerialNo"
                  v-on:keyup="toUpperCaseTyre($event, 'Tyre1')"
                  maxlength="30"
                  type="text"
                  class="form-control capital-input"
                  :class="{'bgc-error-field':correctionInVehicleDetailsData.tyre1SerialNo.errorText !== ''}"
                  placeholder="Tyre 1 Serial Number*"
                />
              </float-label>
               <span class="error-text" v-if="correctionInVehicleDetailsData.tyre1SerialNo.errorText !== ''">
                  {{correctionInVehicleDetailsData.tyre1SerialNo.errorText}}</span>
            </div>
          </div>
          <!--Tyre 1 Serial Number* ends-->
          <!--Tyre 2 Serial Number* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-show="showTyreFieldSpecific('2')">
            <div class="row form-group">
              <float-label label="Tyre 2 Serial Number*" :fixed="isFloat(correctionInVehicleDetailsData.tyre2SerialNo.value)"> 
                <input
                  v-model="correctionInVehicleDetailsData.tyre2SerialNo.value"
                  v-evolvews="correctionInVehicleDetailsData.tyre2SerialNo"
                  v-on:keyup="toUpperCaseTyre($event, 'Tyre2')"
                  maxlength="30"
                  type="text"
                  class="form-control capital-input"
                  :class="{'bgc-error-field':correctionInVehicleDetailsData.tyre2SerialNo.errorText !== ''}"
                  placeholder="Tyre 2 Serial Number*"
                />
              </float-label>
               <span class="error-text" v-if="correctionInVehicleDetailsData.tyre2SerialNo.errorText !== ''">
                  {{correctionInVehicleDetailsData.tyre2SerialNo.errorText}}</span>
            </div>
          </div>
          <!--Tyre 2 Serial Number* ends-->
          <!--Tyre 3 Serial Number* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-show="showTyreFieldSpecific('3')">
            <div class="row form-group">
              <float-label label="Tyre 3 Serial Number*" :fixed="isFloat(correctionInVehicleDetailsData.tyre3SerialNo.value)"> 
                <input
                  v-model="correctionInVehicleDetailsData.tyre3SerialNo.value"
                  v-evolvews="correctionInVehicleDetailsData.tyre3SerialNo"
                  v-on:keyup="toUpperCaseTyre($event, 'Tyre3')"
                  maxlength="30"
                  type="text"
                  class="form-control capital-input"
                  :class="{'bgc-error-field':correctionInVehicleDetailsData.tyre3SerialNo.errorText !== ''}"
                  placeholder="Tyre 3 Serial Number*"
                />
              </float-label>
               <span class="error-text" v-if="correctionInVehicleDetailsData.tyre3SerialNo.errorText !== ''">
                  {{correctionInVehicleDetailsData.tyre3SerialNo.errorText}}</span>
            </div>
          </div>
          <!--Tyre 3 Serial Number* ends-->
          <!--Tyre 4 Serial Number* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-show="showTyreFieldSpecific('4')">
            <div class="row form-group">
              <float-label label="Tyre 4 Serial Number*" :fixed="isFloat(correctionInVehicleDetailsData.tyre4SerialNo.value)"> 
                <input
                  v-model="correctionInVehicleDetailsData.tyre4SerialNo.value"
                  v-evolvews="correctionInVehicleDetailsData.tyre4SerialNo"
                  type="text"
                  class="form-control capital-input"
                  maxlength="30"
                  v-on:keyup="toUpperCaseTyre($event, 'Tyre4')"
                  :class="{'bgc-error-field':correctionInVehicleDetailsData.tyre4SerialNo.errorText !== ''}"
                  placeholder="Tyre 4 Serial Number*"
                />
              </float-label>
               <span class="error-text" v-if="correctionInVehicleDetailsData.tyre4SerialNo.errorText !== ''">
                  {{correctionInVehicleDetailsData.tyre4SerialNo.errorText}}</span>
            </div>
          </div>
          <!--Tyre 4 Serial Number* ends-->
          <!--Tyre 5 Serial Number* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-show="showTyreFieldSpecific('5')">
            <div class="row form-group">
              <float-label label="Tyre 5 Serial Number*" :fixed="isFloat(correctionInVehicleDetailsData.tyre5SerialNo.value)"> 
                <input
                  v-model="correctionInVehicleDetailsData.tyre5SerialNo.value"
                  v-evolvews="correctionInVehicleDetailsData.tyre5SerialNo"
                  type="text"
                  maxlength="30"
                  class="form-control capital-input"
                  v-on:keyup="toUpperCaseTyre($event, 'Tyre5')"
                  :class="{'bgc-error-field':correctionInVehicleDetailsData.tyre5SerialNo.errorText !== ''}"
                  placeholder="Tyre 5 Serial Number*"
                />
              </float-label>
               <span class="error-text" v-if="correctionInVehicleDetailsData.tyre5SerialNo.errorText !== ''">
                  {{correctionInVehicleDetailsData.tyre5SerialNo.errorText}}</span>
            </div>
          </div>
          <!--Tyre 5 Serial Number* ends-->
      </div>
    </div>
</div>
</template>
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
// import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
import vSelect from "vue-select";
import VueTimepicker from "vuejs-timepicker";
import moment from "moment";
import { reactive, onUpdated, onMounted, computed, watch } from "@vue/composition-api";
export default {
    name: "CorrectionInVehicleDetails",
    props: ["showTyreFields","noOfMandatoryTyres","correctionInVehicleDetailsData","disabledGvwField","showCommercialVehicleFields","subTypeData","productCode","fuelType","getSavedQuoteData",'rtaLocationsData'],
    components: {
    FloatLabel,
    Datepicker,
    VueTimepicker,
    vSelect,
  },
  setup(props, context) {
    let state = reactive({});
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const onlyNumber = functions.onlyNumber;
    const isFloat =  functions.isFloat;
    const alphaNumeric = functions.alphaNumeric;
    const ObjDateFormated = functions.ObjDateFormated;
    onMounted(()=>{
      if(props.productCode!='1803'){
        // props.correctionInVehicleDetailsData.vehicleGVW.skip = true;
        // props.correctionInVehicleDetailsData.vehicleGVW.stepsMandatory = false;
        context.root.$set(props.correctionInVehicleDetailsData.vehicleGVW,'skip', true);
        context.root.$set(props.correctionInVehicleDetailsData.vehicleGVW,'stepsMandatory', false);
      }
      // if(props.productCode == '1801' || props.productCode == '1802' || (props.productCode == '1803' && props.getSavedQuoteData.riskDetails.vehicleTypeCode == '27')){
      //   props.correctionInVehicleDetailsData.seatingCapacity.stepsMandatory = true;
      //   delete props.correctionInVehicleDetailsData.seatingCapacity.skip;
      //   props.correctionInVehicleDetailsData.carryingCapacity.stepsMandatory = false;
      //   context.root.$set(props.correctionInVehicleDetailsData.carryingCapacity,'skip', true);
      // }
      // else{
      //   props.correctionInVehicleDetailsData.carryingCapacity.stepsMandatory = true; 
      //   delete props.correctionInVehicleDetailsData.carryingCapacity.skip;
      //   props.correctionInVehicleDetailsData.seatingCapacity.stepsMandatory = false;
      //   context.root.$set(props.correctionInVehicleDetailsData.seatingCapacity,'skip', true);
      // }
      context.parent.calculateSteps();
    })
    onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.correctionInVehicleDetailsData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
      context.parent.enableCalculatePremiumBtn('correctionInVehicleDetails');
    })
    function updateSubtypeDetails(fromSubtype){
      context.parent.updateSubtypeDetails(fromSubtype);
    }
    function setVehicleData(){
      let filteredarray = props.subTypeData.filter(obj => {
        return props.correctionInVehicleDetailsData.vehicleMake.value == (obj.vehicleMake.code+'-'+obj.vehicleModel.code) && obj.vehicleSubType.code == props.correctionInVehicleDetailsData.vehicleSubType.value
      })
    }
    function showTyreFieldSpecific(noTyre){
      return noTyre <= +props.noOfMandatoryTyres ? true : false;
    }
    function toUpperCaseTyre(evt, source){
      if(source == 'Tyre1'){
        props.correctionInVehicleDetailsData.tyre1SerialNo.value = evt.target.value.toUpperCase();
      }
      else if(source == 'Tyre2'){
        props.correctionInVehicleDetailsData.tyre2SerialNo.value = evt.target.value.toUpperCase();
      }
      else if(source == 'Tyre3'){
        props.correctionInVehicleDetailsData.tyre3SerialNo.value = evt.target.value.toUpperCase();
      }
      else if(source == 'Tyre4'){
        props.correctionInVehicleDetailsData.tyre4SerialNo.value = evt.target.value.toUpperCase();
      }
      else if(source == 'Tyre5'){
        props.correctionInVehicleDetailsData.tyre5SerialNo.value = evt.target.value.toUpperCase();
      }
    }
    function setErrorClass(objToCheck,selector){
      if(objToCheck.value == "" || objToCheck.value == null){
        objToCheck.errorText = objToCheck.errorMessage;
        $("."+selector).find("input")[0].classList.add("v-select-error-field");
      }
      else{
        objToCheck.errorText = "";
        $("."+selector).find("input")[0].classList.toggle("v-select-error-field",false)
      }
    }
    const disableInceptionDate= computed(()=>{
      let yearofmanufacture = new Date(props.correctionInVehicleDetailsData.manufacturingYear.value).getFullYear() - 1;
      let endDate = new Date(yearofmanufacture, 12, 1) ;
      let newEndDate = new Date(yearofmanufacture+2, 12, 0) ;
      return {
        from: (moment(ObjDateFormated(props.getSavedQuoteData.motorPolicyBasicDetails.policyInceptionDate)).toDate()>new Date(new moment(newEndDate).endOf('date').toDate()))?
        new Date(new moment(newEndDate).endOf('date').toDate()):moment(ObjDateFormated(props.getSavedQuoteData.motorPolicyBasicDetails.policyInceptionDate)).toDate(),
        to: new Date(new moment(endDate).startOf('date').toDate())
      }
    })
    const disablePastYears = computed(()=>{
      let date = new Date();
      let selectedManufactureYr = parseInt(props.getSavedQuoteData.riskDetails.manufacturingYear);
      let rollOverDateYr;
      if(selectedManufactureYr === (date.getFullYear() - 1)){
        rollOverDateYr = date;
      }else{
        rollOverDateYr = new Date((selectedManufactureYr+1), 11, 31);
      }
      let yearofmanufacture = parseInt(props.getSavedQuoteData.riskDetails.manufacturingYear)-1; //new Date(props.riskDetailsData.yearOfManufacture.value).getFullYear() - 1;
      let endDate = new Date(yearofmanufacture, 12, 1) ;
      if(props.getSavedQuoteData.basicDetails.businessType=='NEW'){
        return{
          from: date,
          to:  new moment(date).subtract(180,'d').toDate()
        }
      }
      else{
        return{
          from: rollOverDateYr,
          to:  new Date(new moment(endDate).startOf('date').toDate())
        }
      }
    })
    const disableManufacturingDate = computed(()=>{
      return{
        from : new Date()
      }
    });
    // const intrimRegLocList = computed(()=>
    //   props.rtaLocationsData.map(obj=>{
    //     return {
    //       label: obj.rtaCode+" - "+obj.rtaCity,
    //       value: obj.rtaCode+"-"+obj.rtaCity
    //     }
    //   })
    // )
    const disableYearForNb= computed(()=>{
      let prevYear = moment(ObjDateFormated(props.getSavedQuoteData.motorPolicyBasicDetails.policyInceptionDate)).toDate()
      let date=new Date();
      if(props.correctionInVehicleDetailsData.registrationDate.value){
        return {
          from: moment(props.correctionInVehicleDetailsData.registrationDate.value).toDate(),
          to: moment(props.correctionInVehicleDetailsData.registrationDate.value).subtract(1, 'y').toDate()
        }
      }
      else{
        return {
          from: prevYear,
          to: moment(date).subtract(65, 'y').toDate()
        }
      }
    })
    const showBatteryDetails = computed(()=>{
      if(props.fuelType.toUpperCase() =='BATTERY(B)' || props.fuelType.toUpperCase() =='BATTERY' || props.fuelType.toUpperCase() =='B'){
        return true;
      }
      else{
        return false;
      }
    });
    watch(() => props.showTyreFields, () => {
      if(props.showTyreFields && props.noOfMandatoryTyres){
        for(let t=1; t<=+props.noOfMandatoryTyres; t++){
          props.correctionInVehicleDetailsData['tyre'+t+'SerialNo'].stepsMandatory = true;
          props.correctionInVehicleDetailsData['tyre'+t+'SerialNo'].skip = undefined;
        }
      }
      else{
        context.root.$set(props.correctionInVehicleDetailsData.tyre1SerialNo,'stepsMandatory', false);
        context.root.$set(props.correctionInVehicleDetailsData.tyre1SerialNo,'skip', true);
        context.root.$set(props.correctionInVehicleDetailsData.tyre2SerialNo,'stepsMandatory', false);
        context.root.$set(props.correctionInVehicleDetailsData.tyre2SerialNo,'skip', true);
        context.root.$set(props.correctionInVehicleDetailsData.tyre3SerialNo,'stepsMandatory', false);
        context.root.$set(props.correctionInVehicleDetailsData.tyre3SerialNo,'skip', true);
        context.root.$set(props.correctionInVehicleDetailsData.tyre4SerialNo,'stepsMandatory', false);
        context.root.$set(props.correctionInVehicleDetailsData.tyre4SerialNo,'skip', true);
        context.root.$set(props.correctionInVehicleDetailsData.tyre5SerialNo,'stepsMandatory', false);
        context.root.$set(props.correctionInVehicleDetailsData.tyre5SerialNo,'skip', true);
      }
    })  
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      onlyNumber,
      alphaNumeric,
      setVehicleData,
      setErrorClass,
      disableInceptionDate,
      disableYearForNb,
      disablePastYears,
      showBatteryDetails,
      disableManufacturingDate,
      toUpperCaseTyre,
      showTyreFieldSpecific,
      updateSubtypeDetails
    };
  },
  directives: {
    evolvews: functions.evolvews
  }
};
</script>
<style scoped>
.subject-gvw{
  font-size: 12px;
}
.v-select-error-field{
  color: #f77a7a !important
}
.manufacturing-date .vdp-datepicker__calendar{
  width: 306px !important;
}
.adv-search{
  margin-top: 21px;
  font-size: 14px;
  color: #0872b9;
  font-weight: normal!important;
}
a.bgc-links.adv-search {
  text-decoration: none;
}
.radio-status {
  margin-top: 30px;
}
::-webkit-input-placeholder { /* WebKit browsers */
  text-transform: none;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  text-transform: none;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  text-transform: none;
}
:-ms-input-placeholder { /* Internet Explorer 10+ */
  text-transform: none;
}
::placeholder { /* Recent browsers */
  text-transform: none;
}
input[type="radio"].bgc-radio + label::before {
  left: -27px;
}
.capital-input{
  text-transform:uppercase;
}
.color-even {
  background-color: rgba(30, 30, 30, 0.05);
}
input[type="text"].claimTextBox {
  line-height: 22px;
  min-height: 17px;
  width: 106px;
}
.claim-height {
  height: 134px;
}
.drop[data-toggle="collapse"]::after{
  content: url(../../../../assets/images/search-up.png);
  padding-left: 9px;
}
.drop[data-toggle="collapse"].collapsed::after{

    content: url(../../../../assets/images/search-down.png);
    padding-left: 9px;
}
@media (max-width: 768px) {
  .claim-height {
    height: 166px;
  }
}
@media only screen and (min-width: 768px) {
  .half-width{
    width: 97.2%;
    margin-left: 1px;
  }
}
@media screen and (max-width: 768px) {
  .inside-half-width{
    margin: 0 auto;
    max-width: 92%;
  }

}
@media screen and (max-width: 576px) {
  .inside-half-width{
    max-width: 95%;
  }
}
@media screen and (max-width: 425px) {
  .inside-half-width{
    max-width: 93%;
  }
}
@media screen and (max-width: 425px) {
  .inside-half-width{
    max-width: 91%;
  }
}
</style>
